import {
    Component,
    ViewChild,
    ElementRef,
    OnInit
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ItemService } from 'src/app/services/item';
import { ReservationService } from 'src/app/services/reservation';
import { PayDepositService } from 'src/app/services/paydeposit';

import { HeaderMenuService } from 'src/app/services/header-menu';
import { LanguageService } from 'src/app/services/language';
import { ModalManager } from 'src/app/modal/global/global';

import * as moment from 'moment';
import { NotificationManager } from 'src/app/notification/notification';

@Component({
    selector: 'paydeposit',
    templateUrl: './paydeposit.html',
    styleUrls: ['./paydeposit.scss']
})
export class PayDepositComponent implements OnInit {
    @ViewChild('externalLink', { static: false }) externalLink: ElementRef;

    public accessID: string;
    public vehicleID: any;
    public reservationID: string;
    public emailAddress: string;
    public reservation: any;
    public booking: any;
    public prices: number;
    public deposit_waiting: boolean = false;

    // View Modifiers
    public cguAccepted: boolean = false;
    public cards = {
        "pricing": true,
        "deposit": true,
        "vehicle": false,
        "location": false,
        "payment": true
    };

    constructor(
        private router: Router,
        private _activatedRoute: ActivatedRoute,
        private reservationService: ReservationService,
        private payDepositService: PayDepositService,
        private modalManager: ModalManager,
        private translateService: TranslateService,
        private itemService: ItemService,
        private languageService: LanguageService,
        private headerMenuService: HeaderMenuService,
        private notificationManager: NotificationManager,
    ) {
        this.languageService.getObservable().subscribe((lang) => {
            moment.locale(lang.i18n);
        });
    }

    ngOnInit() {

        this.headerMenuService.setShowMenu(true);
        this.headerMenuService.setHeader({
            color: 'default',
            showLogo: true,
            showBack: false,
            showIcon: false
        });

        this._activatedRoute.queryParams.subscribe((params) => {
            this.reservationID = params['id'];
            this.emailAddress = encodeURIComponent(params['email']);
            // console.log(params['email'])
            // console.log(encodeURIComponent(params['email']))
            if (this.reservationID == undefined){
                this.reservationID = localStorage.getItem('reservationId')
            }
            this.payDepositService.getReservation({ id: this.reservationID }).toPromise().then((response) => {
                this.reservation = response.result;
                // console.log("confirm-deposit - getReservation: ", this.reservation);

                this.payDepositService.reservationBalance({ id: this.reservation.id}).toPromise().then((response) => {
                    let prices = response.result;
                    let price = 0;
                    for (let i = 0; i < prices.length; i++) {
                        const element = prices[i];
                        if (element.type == "DEPOSIT") {
                            price += element.amount.value;
                        }
                    }
                    if(price > 0){
                        this.deposit_waiting = true;
                    }
                });
                /*
                this.vehicleID = this.reservation.itemId
                this.itemService.getItem({ id: this.vehicleID }).toPromise().then((response) => {
                    this.accessID = response.result.accessId;
                });
                */
                this.checkIfExpired();
            });
        });
    }

    warningCGU() {
        this.modalManager.openModal(this.translateService.instant("GENERIC.warning"), this.translateService.instant("RESERVATION.accept_cgu"), {});
    }

    roundTimeQuarterHour(time) {
        // Find the next closest quarter hour
        let timeToReturn = time;
        timeToReturn.seconds(Math.ceil(timeToReturn.seconds() / 60) * 60);
        timeToReturn.minutes(Math.ceil(timeToReturn.minutes() / 15) * 15);
        return timeToReturn;
    }

    checkIfExpired() {
        let interval = setInterval(() => {
            if (moment().isAfter(this.reservation.end) && this.reservation.status !== 'OPEN') {
                this.router.navigate(['detail'], { queryParams: { id: this.reservationID } });
                clearInterval(interval);
            }
        }, 1000);
    }

    toggleCard(cardType: string) {
        this.cards[cardType] = !this.cards[cardType];
    }
    clickedCGU(data){
        this.cguAccepted = data
    }
}
